import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { THONGKE } from '../constants';
import { Get } from '../../utils/httpProvider';
import { THONGKE_API } from '../../utils/apiUrl';

// Helper to build query params for Get
const buildParams = (model = {}) => {
    const params = {};
    if (model.from) params.from = model.from;
    if (model.to) params.to = model.to;
    if (model.groupBy) params.groupBy = model.groupBy;
    if (model.linhVucId) params.linhVucId = model.linhVucId;
    if (model.nguoiDungId) params.nguoiDungId = model.nguoiDungId;
    if (model.khoaId) params.khoaId = model.khoaId;
    return params;
};

export const getHoTroSummaryAction = createAsyncThunk(
    THONGKE.HOTRO_SUMMARY,
    async (model = {}) => {
        const params = buildParams(model);
        const res = await Get(THONGKE_API.HOTRO_SUMMARY, null, params);
        return res || [];
    }
);

export const getHoTroBreakdownAction = createAsyncThunk(
    THONGKE.HOTRO,
    async (model = {}) => {
        const params = buildParams(model);
        const res = await Get(THONGKE_API.HOTRO, null, params);
        return res || [];
    }
);

export const getYeuCauSummaryAction = createAsyncThunk(
    THONGKE.YEUCAU_SUMMARY,
    async (model = {}) => {
        const params = buildParams(model);
        const res = await Get(THONGKE_API.YEUCAU_SUMMARY, null, params);
        return res || [];
    }
);

export const getYeuCauBreakdownAction = createAsyncThunk(
    THONGKE.YEUCAU,
    async (model = {}) => {
        const params = buildParams(model);
        const res = await Get(THONGKE_API.YEUCAU, null, params);
        return res || [];
    }
);

const initialState = {
    loading: false,
    error: null,
    hoTroSummary: [],
    hoTroBreakdown: [],
    yeuCauSummary: [],
    yeuCauBreakdown: []
};

export const thongKeSlice = createSlice({
    name: THONGKE.NAME_SLICE,
    initialState,
    reducers: {
        clearThongKe: (state) => {
            state.hoTroSummary = [];
            state.hoTroBreakdown = [];
            state.yeuCauSummary = [];
            state.yeuCauBreakdown = [];
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getHoTroSummaryAction.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(getHoTroSummaryAction.fulfilled, (state, action) => { state.loading = false; state.hoTroSummary = action.payload || []; })
            .addCase(getHoTroSummaryAction.rejected, (state, action) => { state.loading = false; state.error = action.error; })

            .addCase(getHoTroBreakdownAction.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(getHoTroBreakdownAction.fulfilled, (state, action) => { state.loading = false; state.hoTroBreakdown = action.payload || []; })
            .addCase(getHoTroBreakdownAction.rejected, (state, action) => { state.loading = false; state.error = action.error; })

            .addCase(getYeuCauSummaryAction.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(getYeuCauSummaryAction.fulfilled, (state, action) => { state.loading = false; state.yeuCauSummary = action.payload || []; })
            .addCase(getYeuCauSummaryAction.rejected, (state, action) => { state.loading = false; state.error = action.error; })

            .addCase(getYeuCauBreakdownAction.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(getYeuCauBreakdownAction.fulfilled, (state, action) => { state.loading = false; state.yeuCauBreakdown = action.payload || []; })
            .addCase(getYeuCauBreakdownAction.rejected, (state, action) => { state.loading = false; state.error = action.error; });
    }
});

export const { clearThongKe } = thongKeSlice.actions;
export default thongKeSlice.reducer;
